// Module
var code = `<avatar>
  <avatar-icon>
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="50"></circle>
    </svg>
    <avatar-initials>
      {{\$ctrl.loanApplicationDetails.customerFirstName.charAt(0) + \$ctrl.loanApplicationDetails.customerLastName.charAt(0)}}
    </avatar-initials>
  </avatar-icon>
</avatar>
<div class="text text-center">{{\$ctrl.loanApplicationDetails.customerEffectiveName}}</div>
<div class="columns--space-between">
  <div>
    <span>CIF</span>
    <span>{{\$ctrl.loanApplicationDetails.customerNumber}}</span>
  </div>
  <div>
    <span>Gender</span>
    <span>{{\$ctrl.loanApplicationDetails.customerGender}}</span>
  </div>
  <div>
    <span>Civil status</span>
    <span>{{\$ctrl.loanApplicationDetails.customerCivilStatus}}</span>
  </div>
  <div>
    <span>Birth Date</span>
    <span>{{\$ctrl.loanApplicationDetails.customerBirthDate | prettyDate}}</span>
  </div>
  <div>
    <span>Birth place</span>
    <span>{{\$ctrl.loanApplicationDetails.customerBirthPlace}}</span>
  </div>
  <div>
    <span>Mobile Number</span>
    <span>{{\$ctrl.loanApplicationDetails.customerMobilePhoneNumber}}</span>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal-customer-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;